// global
// 強引だけどどこからでも呼べる関数用

/**
 * @param {string} meshCode - 該当メッシュコード
 */
window.onClickForMapPopup = (meshCode) => {
  let el = document.getElementById('sel1');
  let devices = el.value;
  console.log(devices);
  window.vueinstans.$children[0].$children[0].getSpectrumData(devices, meshCode);
};
